import { render, staticRenderFns } from "./BtnEspecial.vue?vue&type=template&id=56b35d14&"
import script from "./BtnEspecial.vue?vue&type=script&lang=js&"
export * from "./BtnEspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports